import { Copy, Download, X } from 'lucide-react';
import { Button } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';

export function IntegrationsBulkBar(props: {
  selectedCount: number;
  onExportCsv: () => void;
  onCopyIds: () => void;
  onClear: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-muted-foreground text-sm font-medium">
        {dashboardT('integrations.selectedCount', { count: props.selectedCount })}
      </span>
      <Button type="button" variant="outline" onClick={props.onExportCsv}>
        <Download className="h-4 w-4" aria-hidden="true" />
        {dashboardT('integrations.exportCsv')}
      </Button>
      <Button type="button" variant="outline" onClick={props.onCopyIds}>
        <Copy className="h-4 w-4" aria-hidden="true" />
        {dashboardT('integrations.copyIds')}
      </Button>
      <Button type="button" variant="ghost" onClick={props.onClear}>
        <X className="h-4 w-4" aria-hidden="true" />
        {dashboardT('integrations.clearSelection')}
      </Button>
    </div>
  );
}
